import React, { useEffect, useState, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { AppContext } from '../../../../App'
import AllowClient from '../../../../components.js/serveur/clients/AllowClient'
import LoyaltyCard from '../../../../components.js/serveur/clients/LoyaltyCard'
import ViewBooking from '../../../../components.js/serveur/clients/ViewBooking'
import useFirebase from '../../../../firebase/useFirebase'
import useClients from '../../../../hooks/serveur/clients/useClients'
import usePlanningServeur from '../../../../hooks/serveur/planning/usePlanningServeur'
import HeaderReturn from './../../../../components.js/serveur/siteWeb/HeaderReturn'
import useForm from './../../../../hooks/useForm'
import usePush from './../../../../hooks/usePush'
import ModalSendPushClient from '../../../../components.js/serveur/clients/ModalSendPushClient'
import BookingToComeClient from './../../../../components.js/serveur/clients/BookingToComeClient'
import ViewClient from './../../../../components.js/serveur/clients/ViewClient'
import Spinner from '../../../../components.js/elements/Spinner'
import ModalInfoClient from '../../../../components.js/serveur/clients/ModalInfoClient'
import ModalConfirm from '../../../../components.js/modal/ModalConfirm'
 
const INITIAL_STATE = {
    title:'',
    message:'', 
    idClient:'',
    name:'',
    surname:'',
    phone:'',
} 
 
const Client = () => { 
    const location = useLocation()
    const { user } = useContext(AppContext)
    const [montage, setMontage] = useState(true)
    const { updateData, readData, deleteData, writeData, profil, services, staff, clients, booking, datesOff, messagesChat } = useFirebase()
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const { state } = location
    const { _subtractCardFidelity, _addCardFidelity, _deleteCardFidelity, _allowBooking } = useClients()
    const { _converteTimeToHours } = usePlanningServeur()
    const { handleChange, values, refresh, setValues } = useForm(INITIAL_STATE)
    const { _sendPushNotification } = usePush()
    const [idResetBooking, setIdResetBooking] = useState()
    const [count, setCount] = useState(0)

    useEffect(() => {
        window.scrollTo(0, 0)
        readData(user.uid) 
        setMontage(false)
    },[montage])

    useEffect(() => {
        console.log('Staff useEffect ', count)
        refresh()
    },[count])

    useEffect(() => {
        if (clients) {
            clients.filter(c => c.uid === state.uidClient).map(c => (
                setValues(prev => ({
                    ...prev,
                    idClient:c.id,
                    name:c.name,
                    surname:c.surname,
                    phone:c.phone,
                }))
            ))
        }
    },[clients,booking])

    if (montage) return <Spinner />  

    const _booking =  (uid) => {
        console.log('Client _booking ', uid) 
    }

    const _updateInformationsClient = () => {
        const data = { 
            name:values.name,
            surname:values.surname,
            phone:values.phone ? values.phone : '',
        }
        updateData('entreprises/'+user.uid+'/clients/'+values.idClient,data)
    }

    const _deleteBooking = () => {
        const data = {cancel:true}
        updateData('entreprises/'+user.uid+'/booking/'+idResetBooking,data)
        setIdResetBooking()
    }

    return (
        <div className='container-fluid'>
 
            {clients.filter(c => c.uid === state.uidClient).map(c => (
                <div key={c.id}>
 
                    <HeaderReturn title={c.surname+'  '+c.name} link='/clients'/>

                    {/* BOOKING TO COME CLIENT */}
                    <BookingToComeClient
                        _converteTimeToHours={_converteTimeToHours} 
                        booking={booking}
                        uid={c.uid}
                        _deleteBooking={_deleteBooking}
                        setIdResetBooking={setIdResetBooking}
                    />
 
                    <ViewClient
                        values={values}
                        handleChange={handleChange}
                        _sendPushNotification={_sendPushNotification} 
                        token={c.token}
                        refresh={refresh}
                        state={state}
                        uid={c.uid}
                        messagesChat={messagesChat}
                    />

                    {/* CARTE DE FIDELITE */}
                    <LoyaltyCard
                        _subtractCardFidelity={_subtractCardFidelity} 
                        _addCardFidelity={_addCardFidelity} 
                        _deleteCardFidelity={_deleteCardFidelity}
                        countCardLoyalty={c.countCardLoyalty ? c.countCardLoyalty : 0}
                        keyUid={user.uid}
                        id={c.id}
                        profil={profil}
                    />
 
                    {/* AUTORISATION RESERVATION */} 
                    <AllowClient
                        keyUid={user.uid}
                        id={c.id}
                        allowBooking={c.allow}
                        _allowBooking={_allowBooking}
                    />

                    {/* RESERVATIONS */}
                    <ViewBooking
                        // _booking, booking, uid, _converteTimeToHours
                        _booking={_booking}
                        _converteTimeToHours={_converteTimeToHours} 
                        booking={booking}
                        uid={c.uid}
                        state={state}
                    />  

                    {/* MODALS */} 
                    <ModalSendPushClient
                        values={values}
                        handleChange={handleChange}
                        _sendPushNotification={_sendPushNotification}
                        token={c.token}
                        refresh={refresh}
                        count={count}
                        setCount={setCount}

                    /> 

                    {/* MODAL INFORMATIONS */}
                    <ModalInfoClient
                        values={values}
                        handleChange={handleChange}
                        _updateInformationsClient={_updateInformationsClient}
                        count={count}
                        setCount={setCount}
                    />

                    {/* MODAL CONFIRM */}
                    <ModalConfirm
                        _handleModal={_deleteBooking}
                        title='Êtes-vous sûr de vouloir supprimer le RDV'
                    />

                    {/* RESERVATIONS */}
                    {/* <ViewBooking
                        // _booking, booking, uid, _converteTimeToHours
                        _booking={_booking}
                        _converteTimeToHours={_converteTimeToHours}
                        booking={booking}
                        uid={c.uid}
                    /> */}

                </div>
            ))}
            <div style={{height:400}}/>
        </div>
    )
}

export default Client

/*
<div>page client {state.uidClient}</div>

*/